<template>
    <div class="thumbnailSlider__inner--stageSlider">
        <swiper
            :modules="modules"
            :space-between="8"
            :speed="700"
            :enabled="true"
            :breakpoints="{
             '768': {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true
              },
            }"
            :initialSlide="current"
            @swiper="setMainSwiper"
            @slideChange="onSlideChange"
            :thumbs="{
                swiper: thumbSwiper
            }"
        >
            <swiper-slide v-for="(item) in sliderData">
                <render-vnode :v-node="item"/>
            </swiper-slide>
        </swiper>
        <div class="button-wrapper" v-if="show_arrows">
            <div class="swiper-navigation swiper-prev" @click="mainSwiper.slidePrev()">
                <svg width="18" height="54" viewBox="0 0 18 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M0.78125 26.9958L16.6308 0.806641L17.2289 1.8655L2.02016 26.9958L17.2289 52.1261L16.6308 53.1143L0.78125 26.9958Z"
                          fill="black"/>
                </svg>
            </div>
            <div class="swiper-navigation swiper-next" @click="mainSwiper.slideNext()">
                <svg width="17" height="54" viewBox="0 0 17 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M16.4473 26.9958L0.597733 0.806641L-0.000362396 1.8655L15.2084 26.9958L-0.000362396 52.1261L0.597733 53.1143L16.4473 26.9958Z"
                          fill="black"/>
                </svg>
            </div>
        </div>
    </div>

    <div v-if="desktop && thumbData.length > 6" class="thumbnailSlider__inner--thumbnailSlider">
        <swiper
            :modules="modules"
            :space-between="20"
            :speed="700"
            :slidesPerView="6"
            :freeMode="true"
            :watchSlidesVisibility="true"
            :watchSlidesProgress="true"
            @swiper="setThumbSwiper"
        >
            <swiper-slide v-for="(item) in thumbData">
                <render-vnode :v-node="item"/>
            </swiper-slide>
        </swiper>
        <div class="button-wrapper" v-if="show_arrows">
            <div class="swiper-navigation swiper-prev" @click="mainSwiper.slidePrev()">
                <svg width="18" height="54" viewBox="0 0 18 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M0.78125 26.9958L16.6308 0.806641L17.2289 1.8655L2.02016 26.9958L17.2289 52.1261L16.6308 53.1143L0.78125 26.9958Z"
                          fill="black"/>
                </svg>
            </div>
            <div class="swiper-navigation swiper-next" @click="mainSwiper.slideNext()">
                <svg width="17" height="54" viewBox="0 0 17 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M16.4473 26.9958L0.597733 0.806641L-0.000362396 1.8655L15.2084 26.9958L-0.000362396 52.1261L0.597733 53.1143L16.4473 26.9958Z"
                          fill="black"/>
                </svg>
            </div>
        </div>
    </div>
    <div v-else class="thumbnailSlider__inner--thumbnailTabs-wrapper ">
        <perfect-scrollbar v-if="thumbData.length > 6" class="scrollbar" :class="'c_' + thumbData.length">
            <div class="scrollbarWrapper">
                <div class="thumbnailSlider__inner--thumbnailTabs-inner">
                    <div v-for="(item, i) in thumbData" class="thumbnail" :class="{ active: i === currentIndex}">
                        <render-vnode @click="setActiveItem(i)" :v-node="item"/>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
        <div v-else class="thumbnailSlider__inner--thumbnailTabs-inner" :class="'c_' + thumbData.length">
            <div v-for="(item, i) in thumbData" class="thumbnail" :class="{ active: i === currentIndex}">
                <render-vnode @click="setActiveItem(i)" :v-node="item"/>
            </div>
        </div>
    </div>
</template>

<script>

import SwiperCore, {Thumbs} from 'swiper';
import {Autoplay, Pagination, Navigation} from "swiper";
import {Swiper, SwiperSlide} from "swiper/vue";
import {computed, onMounted, ref} from "vue";
import {windowOrientation, breakpointState} from "@/utils";

SwiperCore.use([Thumbs]);

export default {
    name: "thumb-nail-slider-main-slider",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        sliderData: {
            type: Object,
            required: true
        },
        thumbData: {
            type: Object,
            required: true
        },
        current: {
            type: Number,
            required: true
        }
    },
    setup(props, context) {
        const mainSwiper = ref(null);
        const thumbSwiper = ref(null);
        const sliderData = props.sliderData;
        const thumbData = props.thumbData;
        const current = props.current;
        const currentIndex = ref(0);

        const setMainSwiper = (swiper) => {
            mainSwiper.value = swiper;
        };

        const setThumbSwiper = (swiper) => {
            thumbSwiper.value = swiper;
        };

        const onSlideChange = (swiper) => {
            if (currentIndex.value !== swiper.realIndex) {
                currentIndex.value = swiper.realIndex;
            }
        };

        const setActiveItem = (index) => {
            mainSwiper.value.slideToLoop(index);
        };

        //Windows Functions
        const mobile = computed(() => {
            return breakpointState.value.cur === 'mobile';
        });
        const tablet = computed(() => {
            return breakpointState.value.cur === 'tablet_landscape';
        });
        const desktop = computed(() => {
            return breakpointState.value.cur === 'desktop';
        });
        const show_arrows = computed(() => {
            return windowOrientation.value.width >  1540;
        });

        return {
            mainSwiper,
            thumbSwiper,
            sliderData,
            show_arrows,
            thumbData,
            mobile,
            tablet,
            desktop,
            current,
            currentIndex,
            setMainSwiper,
            setThumbSwiper,
            setActiveItem,
            onSlideChange,
            modules: [Autoplay, Pagination, Navigation],
        }
    }
};
</script>
